import React, { useEffect, useState, useRef } from "react";
import { string } from "prop-types";
import Separator from "../../atoms/separator";

import "./title-with-border.m.css";

function TitleWithBorder({ name }) {
  const [isMobile, setMobile] = useState(false);
  const [lastLineWidth, setWidth] = useState("0px");
  const [display, setDisplay] = useState("none");
  const titleRef = useRef(null);
  useEffect(() => {
    if (window && window.innerWidth < 768 && name.length > 0) {
      setMobile(true);
      if (typeof window !== "undefined") {
        const element = document.querySelector("#dummy-element");
        const ele = titleRef.current;
        if (element || ele) {
          const dummyElement = element && element.getBoundingClientRect();
          const refDummyElement = ele.getBoundingClientRect();
          const lastLineWidth =
            refDummyElement?.left > 0
              ? refDummyElement?.left - 5 + "px"
              : dummyElement && dummyElement?.left - 5 + "px";

          setDisplay("block");
          setWidth(lastLineWidth);
        }
      }
    } else {
      setMobile(false);
    }
  }, []);
  return (
    <div className="titlewithborder-wrapper">
      <div styleName="title-top-seperator">
        <Separator />
      </div>
      <h1>
        {name}
        <span ref={titleRef} id="dummy-element"></span>
      </h1>
      <div styleName="title-seperator-mobile" style={{ left: `${lastLineWidth}`, display: `${isMobile && display}` }}>
        <Separator />
      </div>
    </div>
  );
}

TitleWithBorder.propTypes = {
  name: string
};

export default TitleWithBorder;
